import { Dispatch, SetStateAction } from "react";

import { Button } from "@mui/material";

import { CreateLessonForm } from "./CreateLessonForm";

export type TAddLastLessonButtonProps = {
	order: number;
	addOrder: number | null;
	setAddOrder: Dispatch<SetStateAction<number | null>>;
};

export function AddLastLessonButton({
	order,
	addOrder,
	setAddOrder,
}: TAddLastLessonButtonProps) {
	if (addOrder === order) {
		return (
			<CreateLessonForm
				order={order}
				onClickCancel={() => {
					setAddOrder(null);
				}}
				closeForm={() => {
					setAddOrder(null);
				}}
			/>
		);
	}

	return (
		<Button
			className="normal-button black-button item-separator-small add-class-button"
			onClick={() => {
				setAddOrder(order);
			}}>
			Add Class
		</Button>
	);
}
